import { useTranslation } from 'react-i18next';
import type { PageKey } from '../types';

type Item = {
  key: PageKey;
  labelKey: string;
  icon: React.ReactNode;
};

const MORE_ICON = (
  <svg fill="none" stroke="currentColor" strokeWidth="1.8" viewBox="0 0 24 24">
    <line x1="3" y1="6" x2="21" y2="6" />
    <line x1="3" y1="12" x2="21" y2="12" />
    <line x1="3" y1="18" x2="21" y2="18" />
  </svg>
);

const ITEMS: Item[] = [
  {
    key: 'dashboard',
    labelKey: 'bottom.dashboard',
    icon: (
      <svg fill="none" stroke="currentColor" strokeWidth="1.8" viewBox="0 0 24 24">
        <rect x="3" y="3" width="7" height="7" rx="1" />
        <rect x="14" y="3" width="7" height="7" rx="1" />
        <rect x="3" y="14" width="7" height="7" rx="1" />
        <rect x="14" y="14" width="7" height="7" rx="1" />
      </svg>
    ),
  },
  {
    key: 'clients',
    labelKey: 'bottom.clients',
    icon: (
      <svg fill="none" stroke="currentColor" strokeWidth="1.8" viewBox="0 0 24 24">
        <circle cx="9" cy="7" r="4" />
        <path d="M3 21v-2a4 4 0 014-4h4a4 4 0 014 4v2" />
      </svg>
    ),
  },
  {
    key: 'cases',
    labelKey: 'bottom.cases',
    icon: (
      <svg fill="none" stroke="currentColor" strokeWidth="1.8" viewBox="0 0 24 24">
        <path d="M20 7H4a2 2 0 00-2 2v9a2 2 0 002 2h16a2 2 0 002-2V9a2 2 0 00-2-2z" />
        <path d="M16 7V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v2" />
      </svg>
    ),
  },
  {
    key: 'calendar',
    labelKey: 'bottom.calendar',
    icon: (
      <svg fill="none" stroke="currentColor" strokeWidth="1.8" viewBox="0 0 24 24">
        <rect x="3" y="4" width="18" height="18" rx="2" />
        <line x1="3" y1="10" x2="21" y2="10" />
        <line x1="8" y1="2" x2="8" y2="6" />
        <line x1="16" y1="2" x2="16" y2="6" />
      </svg>
    ),
  },
];

export function BottomNav({
  currentPage,
  onNavigate,
  onOpenMore,
}: {
  currentPage: PageKey;
  onNavigate: (p: PageKey) => void;
  onOpenMore: () => void;
}) {
  const { t } = useTranslation('nav');
  return (
    <nav className="bottom-nav">
      {ITEMS.map((item) => (
        <div
          key={item.key}
          className={`bnav-item ${currentPage === item.key ? 'active' : ''}`}
          onClick={() => onNavigate(item.key)}
        >
          {item.icon}
          {t(item.labelKey)}
        </div>
      ))}
      <div className="bnav-item" onClick={onOpenMore}>
        {MORE_ICON}
        {t('bottom.more')}
      </div>
    </nav>
  );
}
